import { AIMatchSettingsType } from 'components/types';
import * as yup from 'yup';
import { t } from 'i18next';
import { AskRoundSettingsResponse } from 'generated/index';

const schema = yup.object().shape({
  [AIMatchSettingsType.TIMES]: yup
    .array()
    .of(
      yup.object().shape({
        label: yup.string().required(t('validation.valueIsRequired')),
        value: yup.string().required(t('validation.valueIsRequired'))
      })
    )
    .default([])
    .min(1, t('validation.greaterThan', { field: 1 }))
    .max(12, t('aiMatchSettings.maxNotificationsAllowed', { field: 12 }))
    .required(),
  [AIMatchSettingsType.BEFORE_START_LIMIT]: yup
    .number()
    .default(0)
    .min(0, t('validation.greaterThan', { field: 0 }))
    .max(120, t('validation.lessThan', { field: 120 }))
    .typeError(
      t('validation.invalid', { name: t('aiMatchSettings.beforeStartLimit') })
    )
    .required(t('validation.required'))
    .typeError(
      t('validation.invalid', { name: t('aiMatchSettings.beforeStartLimit') })
    )
    .required(t('validation.required')),
  [AIMatchSettingsType.ROUND_MINUTES_BEFORE_START_LIMIT]: yup
    .number()
    .default(0)
    .min(0, t('validation.greaterThan', { field: 0 }))
    .max(120, t('validation.lessThan', { field: 120 }))
    .typeError(
      t('validation.invalid', {
        name: t('aiMatchSettings.roundBeforeStartLimit')
      })
    )
    .required(t('validation.required'))
    .typeError(
      t('validation.invalid', {
        name: t('aiMatchSettings.roundBeforeStartLimit')
      })
    )
    .required(t('validation.required')),
  [AIMatchSettingsType.FLEX_ENABLED]: yup
    .boolean()
    .default(false)
    .notRequired(),
  [AIMatchSettingsType.NON_FLEX_ENABLED]: yup
    .boolean()
    .default(false)
    .notRequired(),
  rounds: yup.array<AskRoundSettingsResponse>().default([]).notRequired()
});

export default schema;
